import { ContentType } from '../../web-legacy/models/apiModels';

export const isCommunityContent = (contentType: ContentType): boolean => {
  // LMC behaves exactly the same as AMC
  return contentType === ContentType.AMC || contentType === ContentType.LMC;
};
